const getCustomerId = customer => {
  const userPrefixMap = { customer: 'c', writer: 'w' };
  const userId = customer?.id || customer?.user_id;
  return `${userPrefixMap[customer?.user_role] || ''}${userId}`;
};

const getAuthMethod = data => data?.method;

export const getDevice = () =>
  typeof window !== 'undefined' && window.innerWidth < 1000 ? 'mobile' : 'desktop';

export const getPageType = () => {
  if (typeof window !== 'undefined' && window.location) {
    const { pathname } = window.location;

    switch (true) {
      case pathname === '/':
        return 'homepage';
      case pathname.includes('blog'):
        return 'blog';
      default:
        return 'landing';
    }
  }

  return 'unknown page';
};

export const GTM_KEY_GETTERS = {
  CUSTOMER_ID: getCustomerId,
  AUTH_METHOD: getAuthMethod,
};
